import React,{useEffect} from 'react';
import "./SpaDecision.css";
import Header from "../../../components/Header";
import Remarks from '../../../components/Remarks/Remarks';
import useAuth from '../../../../customHooks/useAuth';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { baseUrl } from '../../../../common/baseUrl';
import axiosInstance from '../../../../axiosInstance/axiosInstance';
import { HOTEL_TIMEZONE } from "../../../../common/hotelTime";

export default function SpaDecision() {

    const navigate = useNavigate();
    const location = useLocation();
  
    const bookedRoomId = location.state?.bookedRoomId || "";
    const bookingId = location.state?.bookingId || "";
    const requestId = location.state?.requestId || "";
    const userId = location.state?.userId || "";
    const Data = location.state?.Data || {};
    const staffStatus = location.state?.staffStatus || "";
    const status = location.state?.status  || "";


    // Refresh Handle
    useAuth();

    // Check Id
    useEffect(()=>{
        const checkId = ()=>{
            if(userId==="" || bookingId==="" || bookedRoomId===""){
                navigate("/bookings");
            }
        }
      checkId();
    },[userId,bookingId,bookedRoomId,navigate]);

    // Function to format the date (e.g., "07 Oct")
    const formatDate = (dateString) => {
      const date = new Date(dateString);
      const day = date.getDate();
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
      const month = monthNames[date.getMonth()];
      return `${day} ${month}`;
    };

    // Function to format the time (e.g., "22:11")
    const formatTime = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleTimeString([], {
            timeZone: HOTEL_TIMEZONE, hour: '2-digit', minute: '2-digit' });
    };

    // Close Request
    const closeRequest = async()=>{
        try{
            const response = await axiosInstance.put(`/api/v1/users/${userId}/guest-requests/${requestId}/close`);
            // console.log("Request Cancelled : ",response.data);
            toast.success("Spa Request Cancelled Successfully");
            navigate("/bookings",{state : {activeRequests : "requests"}});
        }catch(error){
            toast.error(error?.response?.data?.message || "Some Error Occured");
            console.log(error);
        }
    }

    


  return (
    <div className='spaDecision'>
        <Header title="Spa Request Details"/>

        <div className="spa-details">
            
            {staffStatus && 
                <div className='spaStatus'>
                    <h4>{staffStatus}</h4>
                </div>
            }

            <div className="spaMenu-details">
                <div className="spaMenu-name">
                    <p>{Data.spa_service_name}</p>
                    <p>₹ {Data.total_amount} </p>
                </div>
                <div className="spaMenu-total">
                    <h4>Total</h4>
                    <h4>₹ {Data.total_amount}</h4>
                </div>
            </div>


            <div className="spaOther">

                <div className="spaMenu-field">
                    <h4>Date of the serivce</h4>
                    <div className="spaMenu-inpField">
                        <h5>{formatDate(Data.preferred_time)}</h5>
                    </div>
                </div>

                <div className="spaMenu-field">
                    <h4>Service Time</h4>
                    <div className="spaMenu-inpField">
                        <h5>{formatTime(Data.preferred_time)}</h5>
                    </div>
                </div>

                <div className="spaMenu-field">
                    <h4>Number of People</h4>
                    <div className="spaMenu-inpField">
                        <h5>{Data.number_of_people}</h5>
                    </div>
                </div>

                {Data.additional_comments && 
                    <div className="spaMenu-field">
                        <h4>Comments</h4>
                        <div className="spaMenu-field-comment">
                            <h5>{Data.additional_comments}</h5>
                        </div>
                    </div>
                }
            </div>

        </div>
        
        {Data.remarks && 
            <Remarks para={Data.remarks} />
        }

        { 
            !(status === "Completed_Hotel" || status === "Declined_Hotel" || status === "Declined_Guest" || status === "Closed_Hotel" || status === "Closed_Guest") && (
            <div className="spaMenu-cancel-btn">
                <button onClick={closeRequest}>Cancel Request</button>
            </div>
            )
        }
   
    </div>
  )
}
